module.exports = __webpack_public_path__ + "static/media/homeowner2-1.27039415.png";